export const TRANSPORTOREN_OPTER = 'TRANSPORTOREN_OPTER';
export const TCHALLAND_OPTER = 'TCHALLAND_OPTER';
export const SNABBUD_OPTER = 'SNABBUD_OPTER';
export const LOGTRADE = 'LOGTRADE';
export const C3C = 'C3C';
export const OPTER_V1 = 'OPTER_V1';

export const LOGTRADE_STATUS = {
    complete: 'COMPLETE',
    pending: 'PENDING',
    rejected: 'REJECTED',
    revoked: 'REVOKED'
};

export default function parseIntegrationType(type: string) {
    switch (type) {
        case TRANSPORTOREN_OPTER:
            return 'Opter (Transportören AB)';
        case TCHALLAND_OPTER:
            return 'Opter (TransportCentralen i Halland AB)';
        case SNABBUD_OPTER:
            return 'Opter (SNABBUD i Nyköping AB)';
        case LOGTRADE:
            return 'Logtrade';
        case C3C:
            return 'C3C Logic';
        case OPTER_V1:
            return 'Opter';
        default:
            return '';
    }
}
